module.exports = __webpack_public_path__ + "static/vp3-device.710d8931.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/vp3-device.svg
// module id = 1305
// module chunks = 35783957827783